export default __webpack_public_path__ + "static/media/hht1_storybook_15.8eb3727e.png";